module.exports = __webpack_public_path__ + "media/images/icons/filled/file-image-1ed100ec85efc0521140789318191d75.svg";